export const get_securities = `query get_securities($type: SecurityType!, $list_type: SecurityListType!, $account: String!){
    get_securities(type: $type, list_type: $list_type, account: $account){
        short_name
        name
        stock_market_locality
        currency{
            currency
            name
            decimal
        }
    }
}`;
